import { SpecialFilter } from '../../components/evidence/history-evidence/overrides/table-searchbar';
import { SpecialFilterTextCell } from '../../components/evidence/history-evidence/special-filter-cells/special-filter-text-cell';
import { useSpecialFilterSelectCellFactory } from '../../components/evidence/history-evidence/special-filter-cells/special-filter-select-cell';
import {
  useMinimalDistancesCategorySource,
  useMinimalDistancesDeterminationMethodSource,
} from './minimal-distances-api';
import { ApiFilterOperation } from '@eas/common-web';
import { dictionaryLabelMapper } from '../../components/form/mappers/label-mappers';

export function useSpecialFilters(): SpecialFilter[] {
  return [
    {
      label: 'Číslo zdroje',
      filterkey: 'sourceId',
      FilterCell: SpecialFilterTextCell,
    },
    {
      label: 'Název zdroje',
      filterkey: 'name',
      FilterCell: SpecialFilterTextCell,
    },
    {
      label: 'Zařazení zdroje podle přílohy č. 2a zákona',
      filterkey: 'sourceCategory.id',
      operation: ApiFilterOperation.EQ,
      FilterCell: useSpecialFilterSelectCellFactory(
        useMinimalDistancesCategorySource,
        false,
        dictionaryLabelMapper
      ),
    },
    {
      label: 'Způsob určení minimální vzdálenosti',
      filterkey: 'determinationMethod.id',
      operation: ApiFilterOperation.EQ,
      FilterCell: useSpecialFilterSelectCellFactory(
        useMinimalDistancesDeterminationMethodSource,
        false,
        dictionaryLabelMapper
      ),
    },
  ];
}
